import { FC, memo, useCallback } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { RouterUtils, useNavigate } from 'application/providers/RouterProvider';
import { POINTS_PAGE_PATH } from 'application/consts';
import { useOnboardingActionContext } from 'application/components/common';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { TEXTS } from './texts';
import { useOnboardingContext } from '../../useOnboardingContext';
import { SelectPlayerFlowType } from '../../types';

import styles from '../index.module.scss';

const DeviceRequestedModal: FC<ModalProps[ModalTypes.DEVICE_REQUESTED]> = ({ close }) => {
  const { flowType, currentPoint } = useOnboardingContext();
  const { clearCurrentPoint } = useOnboardingActionContext();

  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    if (flowType === SelectPlayerFlowType.CREATE_DEMO_POINT || currentPoint?.isVideoDemo) {
      navigate(RouterUtils.generatePath(POINTS_PAGE_PATH, { id: currentPoint?.id }), { replace: true });
    }

    clearCurrentPoint();
    close();
  }, [currentPoint?.id]);

  return (
    <ModalScreen
      title={TEXTS.MODAL_TITLE}
      titlePlacement="left"
      onClose={close}
      actionButtons={[
        <Button
          key="button_device_requested_modal_success"
          elementId="button_device_requested_modal_success"
          type={ButtonType.PRIMARY}
          onClick={handleClose}>
          {TEXTS.SUCCESS_BUTTON}
        </Button>,
      ]}>
      <div className={styles.DeviceModalRequested}>{TEXTS.DESCRIPTION}</div>
    </ModalScreen>
  );
};

export default memo(DeviceRequestedModal);
